export interface DraftSummary {
  id: string;
  projectName: string;
  jobNumber: string;
  updatedAt: string;
}

export async function listDrafts(): Promise<DraftSummary[]> {
  const r = await fetch("/api/drafts");
  if (!r.ok) throw new Error("Failed to load drafts");
  return r.json();
}

export async function getDraft(id: string): Promise<{ id: string; data: Record<string, unknown> }> {
  const r = await fetch(`/api/drafts/${id}`);
  if (!r.ok) throw new Error("Failed to load draft");
  return r.json();
}

export async function saveDraft(id: string | null, data: Record<string, unknown>): Promise<string> {
  const url = id ? `/api/drafts/${id}` : "/api/drafts";
  const r = await fetch(url, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ data })
  });
  if (!r.ok) throw new Error("Failed to save draft");
  const out = await r.json();
  return out.id as string;
}

export async function deleteDraft(id: string): Promise<void> {
  const r = await fetch(`/api/drafts/${id}`, { method: "DELETE" });
  if (!r.ok && r.status !== 404) throw new Error("Failed to delete draft");
}
